package dev.bitspittle.droidconSf24.pages.sections.kobweb.silk

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun Widgets2Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/silk/Widgets2.md", mapOf("styles" to listOf("accented-subheaders")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("widgets") }) {
                org.jetbrains.compose.web.dom.Text("Widgets")
            }
            org.jetbrains.compose.web.dom.H3(attrs = { id("checkbox-and-switch") }) {
                org.jetbrains.compose.web.dom.Text("Checkbox and Switch")
            }
            dev.bitspittle.droidconSf24.components.widgets.Code("""var checked by remember { mutableStateOf(false) }

Checkbox(checked, onCheckedChange = { checked = it }) {
    Text("Check me!")
}

Switch(checked, onCheckedChange = { checked = it })
""", "kotlin")
            Horizontal(Modifier.margin(top=2.cssRem)) {
                CheckboxExample(Modifier.scale(1.3))
                SwitchExample(Modifier.scale(1.3))
            }
        }
    }
}
